import { section } from "@/neon";
import { qs } from "@fluorescent/dom";
import { getRecentProducts } from "@/lib/recentlyViewed";
import carousel from "@/components/carousel";
import { makeRequest } from "@/lib/xhr";

const selectors = {
  recentlyViewed: "[data-recently-viewed]",
  recentlyViewedItem: "[data-recently-viewed-item]",
  recentlyViewedProductItem: ".recently-viewed__product-item",
  recentlyViewedSlider: ".recently-viewed-products__slider",
  carousel: ".carousel",
};

section("recently-viewed-products", {
  onLoad() {
    const { limit, productHandle } = this.container.dataset;
    this.limit = parseInt(limit, 10);
    this.recentProductsContainer = qs(
      selectors.recentlyViewedSlider,
      this.container
    );

    // Grab products from localStorage
    const recentProducts = getRecentProducts();

    if (!(recentProducts || []).length) {
      this._removeSection();
      return;
    }

    const recentProductsTrimmed = recentProducts
      .filter(product => product.handle !== productHandle) // don't show current product
      .slice(0, this.limit);

    if (recentProductsTrimmed.length >= 1) {
      this._renderProductItems(recentProductsTrimmed);
    } else {
      this._removeSection();
    }
  },

  _initSlider() {
    this.carousel = carousel(this.container);
  },

  _renderProductItems(products) {
    const actions = products.map(this._renderProductItem.bind(this));
    const results = Promise.all(actions);

    results.then(() => {
      const recentlyViewedProductItem = qs(
        selectors.recentlyViewedProductItem,
        this.container
      );

      if (recentlyViewedProductItem) {
        this._initSlider();
      } else {
        this._removeSection(); // catch the situation where no product handles are valid
      }
    });
  },

  _renderProductItem(product) {
    return new Promise(resolve => {
      const requestUrl = `${theme.routes.products}/${encodeURIComponent(
        product.handle
      )}?section_id=recently-viewed-product-item`;

      makeRequest("GET", requestUrl)
        .then(response => {
          let container = document.createElement("div");
          container.innerHTML = response;

          const productItem = container.querySelector(
            selectors.recentlyViewedItem
          ).innerHTML;

          this.recentProductsContainer.insertAdjacentHTML(
            "beforeend",
            productItem
          );

          resolve();
        })
        .catch(() => {
          console.error(`Recent product "${product.handle}" not found`);
          resolve(); // continue if product not found
        });
    });
  },

  _removeSection() {
    this.container.parentNode.removeChild(this.container);
  },

  onUnload() {
    this.carousel.unload();
  },
});
